import axios from 'axios'
import {errorHelper, messageHelper} from '../helper.js'
import { AUTH_URL } from '../../../vars'

/**
 * @namespace Logout
 */
export default {
    state: {
        
    },
    mutations: {
        
    },
    actions: {
        /**
         * Зазлогиневает пользователя и редиректит на страницу авторизации
         * @throws Ошибка запроса данных
         * 
         * @memberof Logout
         */
        async LOGOUT() {
            localStorage.removeItem('token');
            localStorage.removeItem('isLoggedIn');
            localStorage.removeItem('language');
            
            window.location.href = '/login';
        }
    },
    getters: {
        
    }
}